<template>
  <v-container>
    <v-app-bar color="transparent" flat>
      <div class="title">Photos</div>
      <v-spacer></v-spacer>
      <v-btn icon large @click="dialog = true"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
    </v-app-bar>
    <v-row>
      <v-col cols="12" sm="6" md="4" v-for="(photo, i) in photos" :key="i">
        <v-img :src="photo" height="300" :aspect-ratio="16/9" contain></v-img>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" maxWidth="500" scrollable persistent>
      <v-card>
        <v-row class="mx-1" justify="center" align="center">
          <v-btn-toggle v-model="type" tile color="primary" group>
            <v-btn value="stories">Story</v-btn>
            <v-btn value="plants">Plant</v-btn>
            <v-btn value="birds">Bird</v-btn>
          </v-btn-toggle>
          <v-spacer />
          <v-btn small icon @click="cancelDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        
        <SlimCropper ref="cropper" :options="slimOptions" class="cropper">
          <input ref="picker" type="file" name="slim">
        </SlimCropper>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import uuid from 'uuid'
import { mapActions, mapState } from 'vuex'

import { storage } from '@/plugins/firebase'
import SlimCropper from '@/components/slimCropper/slim'

export default {
  components: { SlimCropper },
  data() {
    return {
      dialog: false,
      type: 'stories',
      storyPhotos: [],
      birdPhotos: [],
      plantPhotos: [],
      ready: false,
      valid: null,
      slimOptions: {
        label: 'Upload Images',
        size: '640,640',
        service: null,
        serviceFormat: 'file',
        forceType: ['png', 'jpeg', 'jpg'],
        post: ['output'],
        filterSharpen: 15,
        download: true
      }
    }
  },
  computed: {
    ...mapState(['user']),
    photos() {
      return [
        ...this.storyPhotos,
        ...this.plantPhotos,
        ...this.birdPhotos
      ]
    }
  },
  methods: {
    ...mapActions(['handleFirebaseError']),
    cancelDialog() {
      this.dialog = false
      this.$refs.cropper.api.remove()
    },
    slimService(formData, progress, success, failure) {
      let file = formData[0]
      // Upload file and metadata to the object 'images/mountains.jpg'
      let pathToImage = `/${uuid()}`
      var uploadTask = storage.ref(this.type).child(pathToImage).put(file)
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        'state_changed', // or 'state_changed'
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          if (progress === 100) {
            success()
          }
        },
        (error) => {
          this.handleFirebaseError(error)
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          failure(error)
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            if (this.type === 'stories') {
              this.storyPhotos.push(downloadURL)
            } else if (this.type === 'plants') {
              this.plantPhotos.push(downloadURL)
            } else if (this.type === 'birds') {
              this.birdPhotos.push(downloadURL)
            }
            this.$refs.cropper.api.remove()
            return downloadURL
          })
        }
      )
    }
  },
  async created() {
    this.slimOptions.service = this.slimService
    try {
      let stories = await storage.ref().child('stories').listAll()
      await stories.items.forEach(async item => {
        let url = await item.getDownloadURL()
        this.storyPhotos.push(url)
      })
      let plants = await storage.ref().child('plants').listAll()
      await plants.items.forEach(async item => {
        let url = await item.getDownloadURL()
        this.plantPhotos.push(url)
      })
      let birds = await storage.ref().child('birds').listAll()
      await birds.items.forEach(async item => {
        let url = await item.getDownloadURL()
        this.birdPhotos.push(url)
      })
    } catch (e) {
      this.handleFirebaseError(e)
    }
    this.ready = true
  },
  destroyed() {
    try {
      this.$refs.cropper.destroy()
    } catch (e) {
      /*...*/
    }
  }
};
</script>
